var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinLogo = function SvgLinkedinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EF",
    d: "M22.228.955H1.772A1.77 1.77 0 0 0 0 2.726v20.457a1.77 1.77 0 0 0 1.772 1.772h20.456A1.77 1.77 0 0 0 24 23.183V2.726A1.77 1.77 0 0 0 22.228.955M7.153 21.4H3.545V9.938h3.608zM5.347 8.35A2.072 2.072 0 1 1 7.43 6.28a2.04 2.04 0 0 1-2.083 2.07m15.106 13.06h-3.606v-6.262c0-1.847-.785-2.417-1.799-2.417-1.07 0-2.12.807-2.12 2.464v6.215H9.32V9.946h3.47v1.589h.047c.348-.705 1.568-1.91 3.43-1.91 2.013 0 4.188 1.195 4.188 4.695z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .955h24v24H0z"
  })))));
};
export default SvgLinkedinLogo;